import styles from './index.module.scss';
import { Button } from '@phi/components';
import { defineComponent, h } from 'vue';
import back_svg from './back.svg';

export default defineComponent({
    emits: {
        click: () => true,
    },

    setup(_, { emit }) {
        return () => h(Button, {
            class: styles.back_button,
            onClick: () => emit('click'),
        }, () => h('img', { src: back_svg }));
    },
});
